import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { L as LINE_DOUBLE } from './viewer-loadable2.js';

var styles = {"divider-container":"_4-MIc","divider-container--double":"n-TYx","divider":"B70rH","divider--single":"_3JsO2","divider--double":"mq7kN","divider--dashed":"bM4B9","divider--dotted":"S8tb-","divider--small":"hmDFr","divider--small--mobile":"J-z1l","divider--medium":"zzQ4C","divider--large--mobile":"-pM6s","divider--medium--mobile":"ca3ce","divider--large":"Athvf","divider--left":"_6piUK","divider--center":"D8R-x","divider--right":"TdE1T","divider--fill-parent":"-Ap85","svgFixerContainer":"pFxyb","emptyChar":"Ia90Q"};

var withSafariSvgCaretFixer = function withSafariSvgCaretFixer(Component) {
  return /* @__PURE__ */React.createElement("div", {
    className: styles.svgFixerContainer
  }, Component, /* @__PURE__ */React.createElement("div", {
    className: styles.emptyChar
  }, "\xA0"));
};

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var lineProps = function lineProps(width, lineDistance) {
  if (lineDistance === void 0) {
    lineDistance = 1;
  }
  return {
    x2: width,
    y1: lineDistance,
    y2: lineDistance
  };
};
var getLines = function getLines(type, width, multilineDistance) {
  if (multilineDistance === void 0) {
    multilineDistance = 7;
  }
  var linePropsArr = [lineProps(width)];
  if (type === LINE_DOUBLE) {
    linePropsArr.push(lineProps(width, multilineDistance));
  }
  return linePropsArr;
};
var DividerLine = function DividerLine(_ref) {
  var type = _ref.type,
    size = _ref.size,
    alignment = _ref.alignment,
    width = _ref.width,
    multilineDistance = _ref.multilineDistance,
    styles = _ref.styles,
    className = _ref.className,
    fillParent = _ref.fillParent,
    isMobile = _ref.isMobile;
  var linesPropsArr = getLines(type, width, multilineDistance);
  var lineClassName = classNames(styles.divider, styles["divider--" + type], styles["divider--" + size + (isMobile ? "--mobile" : "")], styles["divider--" + alignment], fillParent ? styles["divider--fill-parent"] : "", className);
  return withSafariSvgCaretFixer( /* @__PURE__ */React.createElement("svg", {
    className: lineClassName
  }, linesPropsArr.map(function (lineProp, i) {
    return /* @__PURE__ */React.createElement("line", __spreadValues({
      key: i
    }, lineProp));
  })));
};
DividerLine.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.string,
  alignment: PropTypes.string,
  styles: PropTypes.object.isRequired,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  multilineDistance: PropTypes.number,
  fillParent: PropTypes.bool,
  isMobile: PropTypes.bool
};
var DividerLine$1 = DividerLine;

export { DividerLine$1 as D, styles as s };

import 'wix-rich-content-plugin-divider/dist/loadable/viewer/es/styles.viewer.min.global.css'